import React from 'react';
import styled from 'styled-components';
import SubLayout from '../components/layout/SubLayout';
import { businessMenus } from '../data/businessMenus';

const Intro = styled.p`
  font-size: 1.05rem;
  color: #555;
  line-height: 1.9;
  margin-bottom: 50px;
`;

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 50px;
`;

const ServiceCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px 25px;
  background: #fff;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 86, 179, 0.1);
    border-color: #0056b3;
  }

  .icon { font-size: 2rem; margin-bottom: 12px; }
  h4 { font-size: 1.1rem; color: #222; margin-bottom: 8px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.7; }
`;

const SectionLabel = styled.h3`
  font-size: 1.3rem;
  color: #1a2a40;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
`;

const FeatureBox = styled.div`
  background: #f8f9fa;
  border-left: 4px solid #0056b3;
  padding: 20px 25px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 15px;

  h4 { font-size: 1rem; color: #333; margin-bottom: 6px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.6; }
`;

const LawSection = styled.div`
  margin-top: 55px;
`;

const LawBasis = styled.p`
  font-size: 0.88rem;
  color: #777;
  margin-bottom: 16px;

  strong { color: #223E7E; }
`;

const LawDesc = styled.p`
  font-size: 0.95rem;
  color: #555;
  line-height: 1.8;
  margin-bottom: 18px;

  strong { color: #c0392b; }
`;

const TableWrap = styled.div`
  overflow-x: auto;
  margin-bottom: 24px;
`;

const LawTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.92rem;

  th, td {
    border: 1px solid #e5e5e5;
    padding: 12px 16px;
    text-align: left;
    vertical-align: middle;
  }

  thead th {
    background: #223E7E;
    color: #fff;
    font-weight: 700;
    text-align: center;
    white-space: nowrap;
  }

  tbody th {
    background: #f4f6fa;
    color: #1a2a40;
    font-weight: 700;
    white-space: nowrap;
  }

  td.period {
    font-weight: 700;
    color: #223E7E;
    white-space: nowrap;
  }
`;

const SubLabel = styled.p`
  font-weight: 700;
  color: #333;
  margin-bottom: 8px;
  font-size: 0.95rem;
`;

const TargetList = styled.ul`
  margin: 0 0 24px;
  padding-left: 18px;
  font-size: 0.9rem;
  color: #555;
  line-height: 1.85;
`;

const LawNote = styled.p`
  background: #f8f9fa;
  border-left: 4px solid #223E7E;
  padding: 16px 20px;
  border-radius: 0 8px 8px 0;
  font-size: 0.92rem;
  color: #555;
  line-height: 1.75;
`;

const BusinessTank = () => {
  return (
    <SubLayout
      title="물탱크청소"
      sidebarMenus={businessMenus}
      category="사업영역"
      categoryEn="Business"
      bannerBg="/images/bg_building.jpg"
    >
      <Intro>
        주식회사 두성시스템은 저수조(물탱크) 청소 및 위생 관리 서비스를 제공합니다.
        <strong> 법정 의무 저수조 청소</strong>부터 수질 관리까지, 깨끗하고 안전한 급수 환경을
        유지할 수 있도록 전문 인력이 체계적으로 관리합니다.
      </Intro>

      <SectionLabel>주요 서비스</SectionLabel>
      <ServiceGrid>
        <ServiceCard>
          <div className="icon">🚰</div>
          <h4>저수조 청소</h4>
          <p>고압 세척 및 침전물 제거로 저수조 내부를 위생적으로 청소합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">💧</div>
          <h4>수질 검사</h4>
          <p>수질검사기관과의 연계를 통해 법정수질검사까지 진행합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🧽</div>
          <h4>물탱크 위생 관리</h4>
          <p>내부 상태 점검 및 소독으로 세균 번식을 예방하고 청결을 유지합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">📋</div>
          <h4>정기 청소 계약</h4>
          <p>연간 정기 청소 계약으로 법정 주기에 맞춘 관리를 대행합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">📑</div>
          <h4>보고서관리 및 제출</h4>
          <p>저수조청소보고서 기록관리와 수도사업소 제출까지 One-step으로 진행합니다.</p>
        </ServiceCard>
      </ServiceGrid>

      <SectionLabel>특장점</SectionLabel>
      <FeatureBox>
        <h4>법정 의무 청소 대행</h4>
        <p>수도법에 따른 저수조 청소 의무를 정확한 주기로 대행하여 관리 부담을 덜어드립니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>위생적인 수질 관리</h4>
        <p>청소 전후 상태 점검과 내부 청소 및 소독을 통해 깨끗하고 안전한 급수환경을 보장합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>정기 관리 계약 운영</h4>
        <p>연간 계약을 통해 지속적이고 체계적인 저수조 관리 서비스를 제공합니다.</p>
      </FeatureBox>

      <LawSection>
        <SectionLabel>법정 청소 의무 안내</SectionLabel>
        <LawBasis>
          <strong>법적 근거</strong> · 「수도법」 제33조, 같은 법 시행령 제50조, 시행규칙 제22조의4
        </LawBasis>
        <LawDesc>
          건축물의 저수조(물탱크)를 관리하는 소유자·관리자는 법에 따라 다음을 이행해야 합니다.
        </LawDesc>

        <TableWrap>
          <LawTable>
            <tbody>
              <tr>
                <th>저수조 청소</th>
                <td className="period">6개월(반기)마다 1회 이상</td>
              </tr>
              <tr>
                <th>위생상태 점검</th>
                <td className="period">매월 1회 이상</td>
              </tr>
              <tr>
                <th>청소·점검 결과 기록</th>
                <td className="period">작성 후 2년간 보관</td>
              </tr>
            </tbody>
          </LawTable>
        </TableWrap>

        <SubLabel>적용 대상 (대형건축물 등)</SubLabel>
        <TargetList>
          <li>연면적 5,000㎡ 이상 건축물·시설 (주차장 면적 제외)</li>
          <li>둘 이상 용도로 쓰이는 연면적 2,000㎡ 이상 건축물</li>
          <li>대규모점포, 관람석 1,000석 이상 실내체육시설, 객석 1,000석 이상 공연장 등</li>
        </TargetList>

        <LawNote>
          저수조를 청결히 관리하지 않으면 수돗물이 오염될 수 있어, 법으로 정기 청소·점검을 의무화하고 있습니다.
          두성시스템은 법정 주기에 맞춘 청소부터 수질검사기관 연계 검사, 보고서 작성·제출까지 원스텝으로 대행합니다.
        </LawNote>
      </LawSection>
    </SubLayout>
  );
};

export default BusinessTank;
